module.exports = __webpack_public_path__ + "static/text-styles@2x.f849e691.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/text-styles@2x.png
// module id = 450
// module chunks = 114276838955818